import React from 'react';
import AbstractLayout from '../AbstractLayout';
import {IReduxStoreState, IReduxUserState} from '../../../@interfaces';
import {connect} from 'react-redux';
import DefaultLayout from '../Default/DefaultLayout';
import EmptyLayout from '../Empty/EmptyLayout';
import {DefaultLayoutProps} from '../../../@types/components/layouts/DefaultLayout';

class ErrorPageLayout extends AbstractLayout<DefaultLayoutProps & IReduxUserState> {
    render() {
        const Layout = this.props.model ? DefaultLayout : EmptyLayout;

        return <Layout {...this.props}>{this.props.children}</Layout>;
    }
}

export default connect((state: IReduxStoreState) => state.user)(ErrorPageLayout);
